import {TX} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuStateAppResource';

const getters = {
    accessToken: (state) => {
        return state._accessToken;
    },

    refreshToken: (state) => {
        return state._refreshToken;
    },

    authenticating: (state) => {
        return state._authenticating;
    },

    authenticationErrorCode: (state) => {
        return state._authenticationErrorCode;
    },

    authenticationError: (state) => {
        return state._authenticationError;
    },

    loggedIn: (state) => {
        return !!state._accessToken;
    },

    me: (state) => {
        return state._me;
    },

    meTxLicense: (state) => {
        try {
            let l = state._me?.licenses?.toArray() || [];
            let txLicense = l.find(f => f.stateId === TX);
            return txLicense;
        } catch(e) {
            return null;
        }
    },

    meHasValidTxLicense: (state) => {
        try {
            let l = state._me?.licenses?.toArray() || [];
            let txLicense = l.find(f => f.stateId === TX);
            return !!txLicense?.verified;
        } catch(e) {
            return false;
        }
    },

    clientUuid: (state) => {
        return state._clientUuid;
    },

    sellerAgent: (state) => {
        return state._sellerAgent;
    },

    sellerAgentHasValidTxLicense: (state) => {
        try {
            let l = state._sellerAgent?.licenses?.toArray() || [];
            let txLicense = l.find(f => f.stateId === TX);
            return !!txLicense?.verified;
        } catch(e) {
            return false;
        }
    },

    thirdPartyUuid: (state) => {
        return state._thirdPartyUuid;
    },

    thirdPartyInternRedirect: (state) => {
        return state._thirdPartyInternRedirect;
    },

    thirdPartyPlatformList: (state) => {
        return state._thirdPartyPlatformList;
    },

    proxyByV2: (state) => {
        return state._proxyByV2;
    },

    sspToken: (state) => {
        return state._sspToken || {};
    },
};

export default getters;
